import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { ItemListTable } from './ItemListTable.js';
import CheckIcon from '@mui/icons-material/Check';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Typography from '@mui/material/Typography';

const Timeline = ({
  countdown,
  mode = 't_minus',
  datetime_confirmed = false,
  ...props
}) => {
  const timeline = (mode === 't_minus' ? countdown.t_minus : countdown.t_plus) || [];
  const now = Date.now();
  const nextIndex = timeline.findIndex(item => new Date(item.datetime).getTime() > now);
  return /*#__PURE__*/React.createElement(ItemListTable, _extends({
    columns: [{
      field: 'status',
      headerName: '',
      width: 40,
      align: 'center'
    }, {
      field: 'timestamp',
      headerName: mode === 't_minus' ? 'T -' : 'T +',
      width: 90,
      align: 'center'
    }, {
      field: 'jst',
      headerName: 'JST',
      width: 60,
      align: 'center'
    }, {
      field: 'content',
      headerName: ' '
    }],
    rows: timeline.map((item, index) => {
      const dt = new Date(item.datetime);
      const hours = ('0' + dt.getHours()).slice(-2);
      const minutes = ('0' + dt.getMinutes()).slice(-2);
      const isPast = dt.getTime() <= now;
      const isNext = index !== 0 && !isPast && index === nextIndex;
      const style = isPast ? {
        color: '#888'
      } : isNext ? {
        fontWeight: 'bold'
      } : {};
      let icon = /*#__PURE__*/React.createElement(ScheduleIcon, {
        fontSize: "small",
        "aria-label": "upcoming",
        key: `status-${item.timestamp}`
      });
      if (isPast) {
        icon = /*#__PURE__*/React.createElement(CheckIcon, {
          fontSize: "small",
          "aria-label": "completed",
          sx: {
            color: '#888'
          },
          key: `status-${item.timestamp}`
        });
      } else if (isNext) {
        icon = /*#__PURE__*/React.createElement(PlayArrowIcon, {
          fontSize: "small",
          "aria-label": "in-progress",
          key: `status-${item.timestamp}`
        });
      }
      return {
        id: item.timestamp,
        status: icon,
        timestamp: /*#__PURE__*/React.createElement(Typography, {
          sx: style,
          key: `timestamp-${item.timestamp}`
        }, item.timestamp),
        jst: /*#__PURE__*/React.createElement(Typography, {
          sx: style,
          key: `jst-${item.timestamp}`
        }, datetime_confirmed ? `${hours}:${minutes}` : '-'),
        content: /*#__PURE__*/React.createElement(Typography, {
          sx: style,
          key: `content-${item.timestamp}`
        }, item.content)
      };
    })
  }, props, {
    onRowClick: () => {}
  }));
};

export { Timeline, Timeline as default };
